import axios, { AxiosRequestConfig } from 'axios'
// import { JSEncrypt } from 'jsencrypt'
// import { rsaEncryption } from '@/assets/ts/encryption'
import router from '../router/index'
import { userPinia } from '../store/user'
axios.defaults.timeout = 1200000
axios.defaults.baseURL = import.meta.env.VITE_APP_URL
axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (config.method === 'post' && config.data && config.url && !config.url.match(/yqb-oss-file/g)) {
      const isEncrypt = config.data.isEncrypt
      if (isEncrypt) {
        delete config.data.isEncrypt
        // if (process.env.VITE_APP_URL === 'https://api.igeshui.com') {
        //   const rsaObj = rsaEncryption(JSEncrypt, store.state.publicKey, config.data) // 对数据进行加密
        //   console.log(rsaObj)
        //   /* eslint-disable */
        //   config.data = { gs_rsa: rsaObj } // @ts-ignore
        //   /* eslint-enable */
        // }
      }
    }
    // config.cancelToken = new axios.CancelToken(function (c) {
    //   console.log(c)
    // })
    if (config.url && (config.url.match(/\.json/g) || config.url.startsWith('http'))) {
      // config.baseURL = 'https://s.jianfu8.cn'
      // config.baseURL = 'http://192.168.100.42:30080/janefuMerchantsBg'
      config.baseURL = ''
    }
    // if (config.headers) {
    //   const postType = (config.headers.post as any)['Content-Type']
    //   // const contentType =  || config.headers.get[''] || 'application/json'
    //   config.headers['Content-Type'] = postType || 'application/json'
    // }
    const user = userPinia()
    if (user.token && config.headers) {
      // config.headers['Gs-Authorization-ID'] = appName
      config.headers['Admin-Token'] = user.token as string
    }
    return config
  },
  function (error) {
    // console.log(error)
    return Promise.reject(error)
  }
)
// http response 响应拦截器
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error) {
      const user = userPinia()
      const { logout } = user
      const status = error.response ? error.response.status : error.status
      if (status === 401 && !router.currentRoute.value.fullPath.includes('login')) {
        logout()
        router.replace({
          path: '/login',
          query: {
            redirect: router.currentRoute.value.fullPath
          }
        })
      }
    }
    return Promise.reject(error)
  }
)
export default axios
